// Labels for payment run and item statuses (App\Payments\PaymentRuns).
export const RUN_STATUS = {
  pending_approval: "Waiting for approval", approved: "Approved", processing: "Sending", completed: "Paid",
  completed_with_errors: "Paid with errors", rejected: "Rejected", cancelled: "Cancelled",
};
export const ITEM_STATUS = { pending: "To send", sent: "In progress", succeeded: "Paid", failed: "Failed", no_account: "No payout account" };
